import { PlatformPrivateApiConnector } from './PlatformPrivateApiConnector';

export class PlatformPublicApiConnector extends PlatformPrivateApiConnector {

	public initialize() {
		// nothing
	}
}
